/** Dashboard tour flow id → role module key on /dashboard. */
export const DASHBOARD_TOUR_ROLE_BY_FLOW: Record<string, string> = {
  dashboard_coordinator: 'coordinator',
  dashboard_attendee: 'attendee',
  dashboard_training_manager: 'training_manager',
  dashboard_supervisor: 'supervisor',
  dashboard_instructor: 'instructor',
  dashboard_tacticore: 'tacticore',
  dashboard_k9_ops: 'k9_ops',
  // Learning Lab task tours that start on coordinator dashboard tabs
  coordinator_cancel_event: 'coordinator',
  coordinator_create_user: 'coordinator',
  coordinator_manage_venues: 'coordinator',
  coordinator_embed_calendar: 'coordinator',
  coordinator_agency_profile: 'coordinator',
  coordinator_certificates: 'coordinator',
  coordinator_outside_training: 'coordinator',
};

/** DOM anchor that indicates the role module finished mounting. */
export const DASHBOARD_TOUR_READY_TARGET_BY_ROLE: Record<string, string> = {
  attendee: '[data-tour="attendee-tab-events"]',
  coordinator: '[data-tour="coordinator-tab-members"]',
  training_manager: '[data-tour="training-manager-tab-events"]',
  supervisor: '[data-tour="supervisor-tab-activity"]',
  instructor: '[data-tour="instructor-manage-bio"]',
  tacticore: '[data-tour-stable="role-tab-tacticore"]',
  k9_ops: '[data-tour-stable="role-tab-k9_ops"]',
  apt_studio: '[data-tour-stable="role-tab-apt_studio"]',
  americon: '[data-tour-stable="role-tab-americon"]',
};

export function dashboardRoleForTourFlow(flowId: string): string | undefined {
  return DASHBOARD_TOUR_ROLE_BY_FLOW[flowId];
}

export function dashboardReadyTargetForRole(roleKey: string): string | undefined {
  return DASHBOARD_TOUR_READY_TARGET_BY_ROLE[roleKey];
}
